import { defineMessages, type MessageDescriptor } from 'react-intl';

// These keys also are used for analytics.
export enum ActiveImports {
	NONE = '',
	IMPORT_FROM_LOCAL = 'wordDoc',
	IMPORT_FROM_GD = 'gDoc',
	IMPORT_FROM_ONE_DRIVE = 'office365Doc',
	IMPORT_FROM_MARKDOWN = 'markdown',
}

type ImportFolderNames = {
	readonly [ActiveImports.IMPORT_FROM_LOCAL]: MessageDescriptor;
	readonly [ActiveImports.IMPORT_FROM_GD]: MessageDescriptor;
	readonly [ActiveImports.IMPORT_FROM_ONE_DRIVE]: MessageDescriptor;
	readonly [ActiveImports.IMPORT_FROM_MARKDOWN]: MessageDescriptor;
};

const i18n = defineMessages({
	oneDriveFolderName: {
		id: 'import-from-sources.sources-list.oneDriveFolderName',
		defaultMessage: 'OneDrive',
		description:
			'Default name for the folder in the Confluence page tree where documents imported from Microsoft OneDrive are placed. Shown as a page tree node label after an OneDrive import completes.',
	},
	msWordFolderName: {
		id: 'import-from-sources.sources-list.msWordFolderName',
		defaultMessage: 'Word Documents',
		description:
			'Default name for the folder in the Confluence page tree where documents imported from Microsoft Word are placed. Shown as a page tree node label after a Word document import completes.',
	},
	gdocFolderName: {
		id: 'import-from-sources.sources-list.gdocFolderName',
		defaultMessage: 'Google Drive',
		description:
			'Default name for the folder in the Confluence page tree where documents imported from Google Docs are placed. Shown as a page tree node label after a Google Docs import completes.',
	},
	markdownFolderName: {
		id: 'import-from-sources.sources-list.markdownFolderName',
		defaultMessage: 'Markdown',
		description: 'Source label for a page imported from a Markdown file',
	},
});

export const IMPORT_FOLDER_NAMES: ImportFolderNames = {
	[ActiveImports.IMPORT_FROM_LOCAL]: i18n.msWordFolderName,
	[ActiveImports.IMPORT_FROM_GD]: i18n.gdocFolderName,
	[ActiveImports.IMPORT_FROM_ONE_DRIVE]: i18n.oneDriveFolderName,
	[ActiveImports.IMPORT_FROM_MARKDOWN]: i18n.markdownFolderName,
};
